import { Action, createReducer, on } from '@ngrx/store';
import { clearSsrMetrics, completeSsrMetrics, setSsrMetricsSsrCode, startSsrMetrics } from './ssr-metrics.actions';
import { initialSsrMetricsState, SsrMetrics } from './ssr-metrics.state';

const featureReducer = createReducer(
  initialSsrMetricsState,
  on(
    startSsrMetrics,
    (state, { actionType, timestampMillis, confirmationCode }) =>
      ({
        ...state,
        actionType,
        startTimestampMillis: timestampMillis,
        confirmationCode,
      }) as SsrMetrics
  ),
  on(
    setSsrMetricsSsrCode,
    (state, { ssrCode }) =>
      ({
        ...state,
        ssrCode,
      }) as SsrMetrics
  ),
  on(
    completeSsrMetrics,
    (state, { exitReason }) =>
      ({
        ...state,
        exitReason,
      }) as SsrMetrics
  ),
  on(
    clearSsrMetrics,
    (state) =>
      ({
        ...state,
        actionType: undefined,
        exitReason: undefined,
        startTimestampMillis: undefined,
        confirmationCode: undefined,
        ssrCode: undefined,
      }) as SsrMetrics
  )
);

export function ssrMetricsReducer(state = initialSsrMetricsState, action: Action) {
  return featureReducer(state, action);
}
